import React from 'react';
import { withUAPLThemedStyles } from '@bingads-webui-campaign-react/unified-ad-preview-library-core';

import { ImageAdPlacementBase } from './image-ad-placement-base';
import {
  getImageAdPlacementStyles,
  getImageAdPlacementWithImageAsBackgroundStyles,
  getImageAdPlacementWithPlayIconStyles,
} from '../styles';

export const ImageAdPlacementWithImageAsBackground = withUAPLThemedStyles(
  props => (
    <ImageAdPlacementBase
      {...props}
      showShortHeadline
      isMultiLineDescription
      showLongHeadline
      showAdLabel
      showAdInfoLabel
      showGradient
    />
  ),
  getImageAdPlacementWithImageAsBackgroundStyles,
  { componentName: 'ImageAdPlacementWithImageAsBackground' }
);

export const ImageAdPlacementWithRating = withUAPLThemedStyles(
  props => (
    <ImageAdPlacementBase
      {...props}
      showShortHeadline
      showLongHeadline
      showDescription
      showRating
    />
  ),
  getImageAdPlacementStyles,
  { componentName: 'ImageAdPlacementWithRating' }
);

export const ImageAdPlacementWithCTA = withUAPLThemedStyles(
  props => (
    <ImageAdPlacementBase
      {...props}
      showShortHeadline
      showLongHeadline
      showAdInfoLabel
      isAdInfoLabelWithText
      showCallToAction
    />
  ),
  getImageAdPlacementStyles,
  { componentName: 'ImageAdPlacementWithCTA' }
);

export const ImageAdPlacementWithPlayIcon = withUAPLThemedStyles(
  props => (
    <ImageAdPlacementBase
      {...props}
      showAdLabel
      showAdInfoLabel
      showPlayIcon
      showGradient
    />
  ),
  getImageAdPlacementWithPlayIconStyles,
  { componentName: 'ImageAdPlacementWithPlayIcon' }
);
